export default __webpack_public_path__ + "static/media/fsync1.4a78a8ea.png";